module.exports = __webpack_public_path__ + "img/iconAdd.ab390e80.svg";